function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Table, Container, Row, Col } from "react-bootstrap";
import { Skeleton, Tag, Image, Space, Button, Descriptions, Drawer, notification } from "antd";
import Common from "../includes/Common";
import Moment from "react-moment";
import { PencilFill } from 'react-bootstrap-icons';
import EditUserOrganization from "./forms/EditUserOrganization";
import EditUserOrganizationLogo from "./forms/EditOrganizationLogo";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MyOrganization = function MyOrganization() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    company = _useState2[0],
    setCompany = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isEditFormVisible = _useState8[0],
    setIsEditFormVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataChanged = _useState10[0],
    setIsDataChanged = _useState10[1];
  useEffect(function () {
    setIsDataChanged(false);
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getuserorganization/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) setCompany(response.data.organization);else setErrorMessage(response.data.message);
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue, verifiez votre connexion internet");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          sm: 10,
          children: [company != null && /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 7,
              md: 7,
              sm: 8,
              xs: 9,
              children: /*#__PURE__*/_jsxs("div", {
                className: "image-box",
                style: {
                  background: "#FFFFFF",
                  padding: "20px 10px"
                },
                children: [/*#__PURE__*/_jsxs(Descriptions, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "INFOS STRUCTURE"
                  }),
                  column: 2,
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Label"
                    }),
                    children: company.label
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Contact"
                    }),
                    children: company.mobile
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "E-mail"
                    }),
                    children: company.email
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Adresse"
                    }),
                    children: company.address
                  })]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setIsEditFormVisible(true);
                    },
                    children: [/*#__PURE__*/_jsx(PencilFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " MODIFIER"
                    })]
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(EditUserOrganizationLogo, {
                organization: company
              })
            })]
          }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          })]
        })
      })
    }), company != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER"
      }),
      width: "250px",
      open: isEditFormVisible,
      onClose: function onClose() {
        setIsEditFormVisible(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(EditUserOrganization, {
        organization: company,
        handler: function handler() {
          setIsDataChanged(true);
          setIsEditFormVisible(false);
          notification.success({
            message: "Ok!",
            description: "Modifations enregistrées"
          });
        }
      })
    })]
  });
};
export default MyOrganization;